import { useState } from 'react'
import { Button, Row, Tab, Tabs } from 'react-bootstrap'
import SearchBar from './components/SearchBar'
import { useMediaQuery, mediaQueryPoint } from 'utils/hooks'
import GameContent from './components/GameContent'
import HomeSlider from './components/HomeSlider'
import notiIcon from 'assets/images/notification.svg'
import { useTranslation } from 'react-i18next'
import HomeSliderMobile from './components/HomeSliderMobile'
import { makeData } from 'utils/makeData'
import { useLocation } from 'react-router-dom'

function HomePage() {
	const { t } = useTranslation()
	const location = useLocation()

	const [valueSearch, setValueSearch] = useState('')
	const [key, setKey] = useState('all-game')
	const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.sm}px)`)
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)

	const notiData = makeData('noti', 3)

	// TODO: Suspense implementation
	// TODO: Search game combobox dropdown
	return (
		<>
			<div className="home-slider mt-3 mt-md-0">
				{isMobileMD ? <HomeSliderMobile /> : <HomeSlider />}
				<div
					style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
				>
					<div className={`noti ${isMobileMD ? '' : 'noti-big'}`}>
						{/* <p>{t('congrat')}</p> */}
						<div className="noti-text">
							<img src={notiIcon} alt="Winner notification" />
							{notiData?.map(item => (
								<span key={item.id}>
									{t('congrat')
										.replace('_PLAYER_', item.player)
										.replace('_REWARD_', item.reward)}
								</span>
							))}
						</div>
					</div>
				</div>
			</div>
			<Row className="home-games px-0 px-sm-auto">
				<Tabs
					id="controlled-tab-example"
					activeKey={key}
					onSelect={k => setKey(k)}
					className="mx-0 mx-sm-2"
				>
					<Tab eventKey="all-game" title={t('all-game')}>
						<GameContent valueSearch={valueSearch} />
					</Tab>
					<Tab eventKey="how-to-play" title={t('game_card.how_to_play')}>
						<GameContent type={'how-to-play'} valueSearch={valueSearch} />
					</Tab>
					{/* <Tab eventKey="mortalwar" title="MORTALWAR">
						<GameContent valueSearch={valueSearch} />
					</Tab> */}
				</Tabs>

				{isMobile ? null : (
					<div className="search-bar">
						<SearchBar
							type="text"
							placeholder={t('search_bar')}
							onChange={e => {
								setValueSearch(e.target.value)
							}}
							onPaste={e => e.preventDefault()}
							onDrop={e => e.preventDefault()}
						/>
					</div>
				)}
			</Row>
		</>
	)
}

export default HomePage
